module.exports = __webpack_public_path__ + "static/pic05-e496309a53749f1cd75eb5b3b52a9fb6.jpg";